export class ResponseWrapper {
  constructor(response) {
    this.data = response?.data?.data ?? response?.data ?? {}

    this.statusCode = response.status
    this.message = this.data?.message || response.data?.message || ''
    this.headers = response.headers
  }
}
